import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export type TDiscountLabel = {
    $bgColor?: COLORS,
}

const DiscountLabel = styled.div<TDiscountLabel>`
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    flex-shrink: 0;
    
    width: 38px;
    height: 26px;
    line-height: 26px !important;
    border-radius: 6px;
    transform: rotate(-3.117deg);
    
    background-color: ${({ $bgColor = COLORS.ButtonAccent }) => $bgColor};
    color: ${COLORS.TextWhite};
    ${FONTS.MediumXXS};
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        width: 56px;
        height: 32px;
        line-height: 32px !important;
        transform: rotate(-4.392deg);
        ${FONTS.H5};
    }
`;

export default DiscountLabel;
